import envConfig from '@/config/environment';
import generalConfig from '@/config/general'; // TODO throw errors when price id
// environment variables are unset

const MAX_FREE_CHARTS = 5;
const MAX_STARTER_WIDGETS = 10;
const MAX_GROWTH_WIDGETS = 3;
export const FREE_SEAT = {
  nickname: 'free',
  price: 0,
  title: 'Free',
  viewLimit: 500,
  chartLimit: 5,
  usps: [`${MAX_FREE_CHARTS} Charts`, 'Limited templates', 'Limited themes'],
  permissions: {
    canCopyWidgetSnippet: true
  }
};
export const STARTER_SEAT = {
  nickname: 'starter',
  price: 20,
  priceId: process.env.NEXT_PUBLIC_STRIPE_STARTER_PRICE_ID || '',
  title: 'Starter',
  viewLimit: 10000,
  chartLimit: Infinity,
  usps: [`${MAX_STARTER_WIDGETS} Dashboards`, 'Template Database', 'Priority Chat Support', `Remove ${generalConfig.productName} Logo`, 'Google Sheet Sync']
};
export const CREATOR_SEAT = {
  nickname: 'creator',
  price: 16,
  priceId: process.env.NEXT_PUBLIC_STRIPE_CREATOR_PRICE_ID || '',
  title: 'Creator',
  viewLimit: 10000,
  chartLimit: Infinity,
  usps: [`Unlimited Charts`, 'Full template database', 'Full theme options', `Remove ${generalConfig.productName} logo from interactive charts`, 'Real-time Google Drive sync', 'Chat support']
};
export const GROWTH_SEAT = {
  nickname: 'growth',
  price: 40,
  priceId: process.env.NEXT_PUBLIC_STRIPE_GROWTH_PRICE_ID || '',
  title: 'Growth',
  viewLimit: 100000,
  chartLimit: Infinity,
  usps: [`Everything in ${CREATOR_SEAT.nickname}`, `${MAX_GROWTH_WIDGETS} Dashboards`]
};
export const ENTERPRISE_SEAT = {
  nickname: 'enterprise',
  priceId: 'TODO',
  viewLimit: Infinity,
  chartLimit: Infinity,
  title: 'Enterprise',
  usps: ['Unlimited Views', 'Unlimited Charts', 'Unlimited Dashboards']
};
export const seats = [FREE_SEAT, STARTER_SEAT, CREATOR_SEAT, GROWTH_SEAT, ENTERPRISE_SEAT];
export const products = [CREATOR_SEAT, GROWTH_SEAT];
export const advertising = {
  active: envConfig.isProduction && false
};
export default {
  seats,
  products,
  advertising,
  maximumFreeWidgets: MAX_FREE_CHARTS,
  maximumFreeCharts: MAX_FREE_CHARTS
};